import styled from 'styled-components';

const S = {
  Layout: styled.div`
    display: flex;
    align-items: center;
    flex-direction: column;
  `,
  Container: styled.div`
    display: flex;
    flex-direction: column;

    padding: 7.5rem 350px 10rem;
  `,
};

export { S };
